export default __webpack_public_path__ + "static/media/mnschedule_navicon.1aa6b53d.svg";